import { FC } from 'react';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { ACCOUNT_STATUS, usePolling, useStores } from '~/utils';
import OnboardingConfirmation from './OnboardingConfirmation';

const OnboardingConfirmationContainerContainer: FC = () => {
  const { creditProducts, user } = useStores();
  const navigate = useNavigate();

  const checkAccountStatus = async () => {
    try {
      const { account } = await user.fetchUserData();
      if (account.accountStatus !== ACCOUNT_STATUS.WAITING_DOCUMENT) {
        stopPolling();
        navigate(`/${creditProducts.qrCodeId}`);
      }
    } catch (error) {
      navigate(Routes.ERROR_SCENE, {
        state: {
          title: 'Erro ao verificar dados do usuário',
          subtitle: 'Por favor, tente novamente mais tarde',
        },
      });
    }
  };

  const stopPolling = usePolling({
    pollingFunction: checkAccountStatus,
    interval: 5000,
    executeImmediately: true,
  });

  return <OnboardingConfirmation />;
};

export default observer(OnboardingConfirmationContainerContainer);
